var map = {
	"./Angular Material.webp": 6390,
	"./ChatGPT.webp": 8865,
	"./Claude.webp": 2470,
	"./Diagrams.net.webp": 8397,
	"./Docker Compose.webp": 5322,
	"./EJS.webp": 3876,
	"./Entity Framework.webp": 8781,
	"./Figma.webp": 2934,
	"./Gemini.webp": 1210,
	"./GitLab.webp": 7504,
	"./Github Copilot.webp": 7430,
	"./IntelliJ IDEA.webp": 1132,
	"./JUnit.webp": 7568,
	"./Lombok.webp": 8108,
	"./MongoDB Atlas.webp": 7260,
	"./Mongoose.webp": 9779,
	"./NgRx.webp": 6621,
	"./Postman.webp": 3114,
	"./SQL Server.webp": 3574,
	"./SQLite.webp": 733,
	"./Spring Data JPA.webp": 1350,
	"./Swagger.webp": 4168,
	"./Twig.webp": 7383,
	"./Vue.webp": 706,
	"./gft.webp": 6610,
	"./github-white.webp": 9328,
	"./github.webp": 6854,
	"./globe.webp": 7829,
	"./kg.webp": 1762,
	"./linkedin.webp": 9059,
	"./tec.webp": 9614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1654;